module.exports = __webpack_public_path__ + "static/media/Houndoom_gaussian2.43050993.png";